// extracted by mini-css-extract-plugin
export var menuIcon = "_p9-0";
export var menuIconInline = "_p9-1";